import React, { useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { FaRegEye } from "react-icons/fa";
import { FaRegEyeSlash } from "react-icons/fa";
import "../assets/scss/LoginPage.scss";
import { getUserToken } from "../action/api-services";
import { setUserTokenReducer } from "../redux/slice/userToken";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const LoginPage = () => {
  const dispatch = useDispatch();
  const [username, setUserName] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = (e) => {
    e.preventDefault();
    if (!username) {
      toast.error("Username/Email is required!");
      return;
    } else if (!password) {
      toast.error("Password is required!");
      return;
    } else if (username || password) {
      // setUserName("");
      // setPassword("");

      let payload = {
        username: username,
        password: password,
      };

      getUserToken(payload)
        .then(function (response) {
          // console.log(">>>>>>>>>>>", response, response.status)
          if (response.status === 200) {
            dispatch(setUserTokenReducer(response.data.token));
            let token_expiry = 24 * 60 * 60 * 1000;
            sessionStorage.setItem("token_expiry", Date.now() + token_expiry);
            sessionStorage.setItem("userToken", response.data.token);
            toast.success("Login successful!");
            navigate(`/`);
          } else {
            toast.error(response.data.message);
          }
        })
        .catch(function (err) {
          console.log("Error", err);
        });
    }
  };

  return (
    <div className="login-page">
      <div className="card p-4">
        <h1 className="text-center mb-4 fs-6">Login</h1>
        <form onSubmit={handleLogin}>
          <div className="row">
            <div className="col-12">
              <div className="position-relative text-start mb-4">
                <input
                  type="text"
                  className={`form-control ${username ? "fillData" : ""}`}
                  id="username"
                  value={username}
                  onChange={(e) => setUserName(e.target.value)}
                  autoComplete="off"
                />
                <label htmlFor="username" className="form-label">
                  Username/Email
                </label>
              </div>
            </div>
            <div className="col-12">
              <div className="position-relative text-start mb-4">
                <input
                  type={showPassword ? "text" : "password"}
                  className={`form-control ${password ? "fillData" : ""}`}
                  id="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  autoComplete="off"
                  // style={{ paddingRight: '32px' }}
                />
                <label htmlFor="password" className="form-label">
                  Password
                </label>
                {/* {password ? <span onClick={() => setShowPassword(!showPassword)} className="position-absolute top-50 translate-middle-y bg-white" style={{ cursor: "pointer", right: '10px' }}>
                                    {showPassword ?
                                        <FaRegEyeSlash />
                                        : <FaRegEye />}
                                </span> : null} */}
              </div>
            </div>
            <div className="col-12 d-flex justify-content-center">
              <button type="submit" className="btn btn-primary px-4 py-2">
                Login
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
